import { BookOpen, Briefcase, FileText, Lightbulb, Scale, Shield } from 'lucide-react';

const workflowCategories = [
  {
    icon: Scale,
    title: 'Litigation & Discovery',
    workflows: [
      'Document review and analysis',
      'Case research and strategy',
      'Deposition preparation',
      'Discovery response drafting',
    ],
  },
  {
    icon: Briefcase,
    title: 'Transactions & Contracts',
    workflows: [
      'Contract review and redlining',
      'Due diligence analysis',
      'Deal document drafting',
      'Closing checklist management',
    ],
  },
  {
    icon: Shield,
    title: 'Regulatory & Compliance',
    workflows: [
      'Regulatory research',
      'Compliance policy drafting',
      'Risk assessment',
      'Audit preparation',
    ],
  },
  {
    icon: Lightbulb,
    title: 'Intellectual Property',
    workflows: [
      'Patent search and prior art',
      'Patent drafting and prosecution',
      'Trademark clearance',
      'Freedom-to-operate analysis',
    ],
  },
  {
    icon: BookOpen,
    title: 'Legal Research',
    workflows: [
      'Legal memoranda',
      'Brief drafting support',
      'Statutory and case law research',
      'Client communications',
    ],
  },
  {
    icon: FileText,
    title: 'Document Automation',
    workflows: [
      'Template generation',
      'Form completion',
      'Document summarization',
      'Comparison and markup',
    ],
  },
];

export function LegalWorkflows() {
  return (
    <section id="features" className="py-20 sm:py-32 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Built for How Legal Professionals Work
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Pre-built and custom workflows across practice areas
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-7xl">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {workflowCategories.map((category) => {
              const Icon = category.icon;
              return (
                <div
                  key={category.title}
                  className="relative rounded-lg border border-gray-200 bg-white p-6 shadow-sm transition-shadow hover:shadow-md"
                >
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-blue-100">
                    <Icon className="h-6 w-6 text-blue-600" />
                  </div>
                  <h3 className="mb-4 text-lg font-semibold text-gray-900">{category.title}</h3>
                  <ul className="space-y-2">
                    {category.workflows.map((workflow) => (
                      <li key={workflow} className="flex items-start gap-2 text-sm text-gray-600">
                        <span className="text-blue-600 mt-0.5">•</span>
                        <span>{workflow}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>

        {/* Note about customization */}
        <div className="mx-auto mt-12 max-w-3xl text-center">
          <p className="text-gray-600">
            Don't see your workflow? SafeIdea supports custom workflows—define your own processes
            and templates to match how you already work.
          </p>
        </div>
      </div>
    </section>
  );
}
